const pl = {
    home1: "Diagnosta Laboratoryjny",
    home2: "O Mnie",
    home3: "Umiejętności",
    home4: "Projekty",

    about1: "Cześć!",
    about3: "Front-end developer",
    about4: "i",
    about5: "diagnosta laboratoryjny",
    about6: "Swoją przygodę z ",
    about7: "programowaniem",
    about8: " rozpoczęłam niedawno. Zdecydowałam się na stacjonarny kurs, dzięki któremu odkryłam, że programowanie jest czymś, co chcę robić i co sprawia mi przyjemność. Poprzednio pracowałam jako",
    about8a: "Zmiana mojej ścieżki kariery był wyzywająca, ale teraz jestem z tej decyzji dumna.",
    about9: "w szpitalu.",
    about10: "Kilka lat temu odkryłam swoje zamiłowanie do ",
    about11: "koreańskiej kultury",
    about12: ", dzięki czemu teraz w każdej wolnej chwili (prócz kodowania!) również uczę się",
    about13: "samodzielnie języka koreańskiego.",
    about14: "",
    about15: "",
    about16: "Uwielbiam odkrywać ",
    about17: "nowe kraje",
    about18: "poznawać ich kulturę.",
    about19: "Nie mogłabym żyć bez",
    about20: "muzyki",
    about21: "dzięki niej mogę się uśmiechać każdego dnia : )",
    about22: "",

    skills1: "Umiejętności",
    skills2: "Narzędzia/inne",
    skills3: "Uczę się",

    projects1: "Projekty",
    projects2: "wróć",
    projects3: "Użyto",
    projects4: "Język",
    projects5: "Kod",
    projects6: "Live",



};

export default pl;